<!-- please put app-toast outside ion-app tag, because ngOnInit() always called twice in there -->
<app-toast></app-toast>

<ion-app [style.background]="appBgColor()">
  <app-acl></app-acl>
  <app-auth></app-auth>
  <app-lang></app-lang>
  <app-back [router]="iro()"></app-back>
  <app-clipboard></app-clipboard>
  <app-deeplinks></app-deeplinks>
  <app-network></app-network>
  <app-one-signal></app-one-signal>
  <app-overlay></app-overlay>
  <app-reminder></app-reminder>
  <app-update></app-update>
  <app-sentry></app-sentry>
  <app-status-bar></app-status-bar>
  <app-keyboard></app-keyboard>
  <app-tracker-sync></app-tracker-sync>
  <app-screen-orientation></app-screen-orientation>
  <app-assistant-subscription-plan-recommendation-modal></app-assistant-subscription-plan-recommendation-modal>
  <app-sync-device-timezone></app-sync-device-timezone>
  <app-heartbeat></app-heartbeat>

  <main id="app-main" [class.hide]="hideMainElement">
    <section id="router-outlet-wrapper">
      <ion-router-outlet [swipeGesture]="true"></ion-router-outlet>
    </section>
  </main>
</ion-app>
